import "babel-polyfill"
import "react-app-polyfill/ie11";
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async';
import config from './config'
import store from './store'
import ViewRouter from './router'
import { Provider } from 'react-redux'
import i18n from 'i18next'
import './i18n'
import './style/foot.less'
import './style/mstyle.less'
import './style/pop.less'
import { setI18n, getNavigatorLang } from "./utils/i18nUtil";
window.GLOBALCONFIG = {
    APIHOST: config[process.env.NODE_ENV as string]
}

const urlParams = new URL(window.location.href);//将字符串变成url对象
const isHasLang = urlParams.searchParams.has("lang");
if (isHasLang) {
    const getLang = urlParams.searchParams.get("lang");
    const defaultLanguage = localStorage.getItem('i18nextLng') || 'zh_CN'
    const language = getLang || defaultLanguage;
    i18n.changeLanguage(language);
    setI18n(getLang);
    localStorage.setItem('i18nextLng', language);
} else {
    const navigatorLang = navigator.language;
    setI18n(navigatorLang);
    const browserLang = getNavigatorLang();
    i18n.changeLanguage(browserLang)
    localStorage.setItem('i18nextLng', browserLang);
}



createRoot(document.getElementById('root')).render(
    <HelmetProvider>
        <React.StrictMode>
            <BrowserRouter>
                <Provider store={store}>
                    {/* 启用页面路由 */}
                    <ViewRouter></ViewRouter>
                </Provider>
            </BrowserRouter>
        </React.StrictMode>
    </HelmetProvider>
)